import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom/";
import FormBuilderPOC3 from "../../../components/Form_Builder_POC/FormBuilderPOC3";
import { Button, Alert } from "antd";
import { addFormResponse } from "../../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { ADD_FORM_RESPONSE } from "../../../redux/constants/type";

function Form() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { formId } = useParams();
  const [responses, setResponses] = useState(null);
  const formComponents = JSON.parse(localStorage.getItem("formComponents"));
  const checkResponse = useSelector((state) => state.user.formResponse);
  const [showSuccess, setShowSuccess] = useState(false);

  const changeValues = (sectionId, fieldId, e) => {
    let value = "";
    if (typeof e === "object" && Array.isArray(e)) value = e[0];
    else if (typeof e === "object") value = e.target.value;
    else if (typeof e === "string") value = e;
    let updatedResponse = [...responses];
    updatedResponse = updatedResponse.map((sec) => {
      if (sec.id === sectionId) {
        return {
          ...sec,
          children: sec.children.map((field) => {
            if (field.id === fieldId)
              return { ...field, value: value ? value : "" };
            else return { ...field };
          }),
        };
      } else return { ...sec };
    });
    setResponses(updatedResponse);
  };

  const submitFormResponse = async () => {
    const userid = localStorage.getItem("userid");
    const answers = [];
    for (let section of responses) {
      for (let field of section.children) {
        const obj = {
          userid,
          formId,
          formSectionid: field.parentId,
          sectionFieldid: field.sectionFieldid,
          // taskid: location?.state?.taskId,
          question: field.title,
          answer: field.value ? field.value : "",
        };
        if (location?.state?.taskId) {
          obj.taskid = location.state.taskId;
        }
        answers.push(obj);
      }
    }
    try {
      const submitAnswers = await Promise.resolve(
        dispatch(addFormResponse(answers))
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (formComponents) {
      setResponses(formComponents);
    }
  }, []);

  useEffect(() => {
    if (checkResponse && checkResponse.status === true) {
      setShowSuccess(true);
      setTimeout(() => {
        dispatch({
          type: ADD_FORM_RESPONSE,
          data: {},
        });
      }, 1000);
    }
  }, [checkResponse]);

  useEffect(() => {
    if (showSuccess) {
      // setTimeout(() => window.close(), 5000);
      setTimeout(() => {
        if (window.history.length > 1) {
          history.goBack();
        } else {
          window.close();
        }
      }, 5000);
    }
  }, [showSuccess]);

  return (
    <>
      {showSuccess ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
            marginTop: "20%",
          }}
        >
          <Alert
            showIcon
            type="success"
            message="Response submitted successfully!"
          />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "2rem",
            gap: "2rem",
            padding: "2rem",
          }}
        >
          <FormBuilderPOC3
            formComponents={formComponents}
            showMenu={false}
            onCheck={(a, b, c) => changeValues(a, b, c)}
          />

          <Button type="primary" onClick={submitFormResponse}>
            Submit
          </Button>
        </div>
      )}
    </>
  );
}

export default Form;
